export interface ChecklistItem {
  id?: string;
  label?: string;
  checked?: boolean;
  note?: string | null;
}

export interface CheckedChecklistItem {
  label: string;
  note?: string | null;
}

export function getCheckedChecklistItems(value: unknown): CheckedChecklistItem[] {
  if (!Array.isArray(value) || value.length === 0) {
    return [];
  }

  return value
    .filter((item): item is ChecklistItem => {
      return item && typeof item === "object" && !!item.checked;
    })
    .map((item) => ({
      label: item.label || item.id || "",
      note: item.note,
    }))
    .filter((item) => item.label !== "");
}

export function formatChecklistItemForPdf(item: CheckedChecklistItem): string {
  if (!item?.label) {
    return "";
  }

  if (item.note === undefined || item.note === null || item.note === "") {
    return item.label;
  }

  return `${item.label} - ${item.note}`;
}

export function formatChecklistForPdf(value: unknown): string {
  const items = getCheckedChecklistItems(value)
    .map(formatChecklistItemForPdf)
    .filter(Boolean);

  if (items.length === 0) {
    return "—";
  }

  return items.join("\n");
}